<template>
    <q-editor v-model="showFormModal" min-height="5rem" :toolbar-rounded="true" id="editor-description" :toolbar="[
        ['left', 'center', 'right', 'justify'],
        ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
        ['token', 'hr', 'link', 'custom_btn', 'fullscreen'],
        [
            {
                label: $q.lang.editor.formatting,
                icon: $q.iconSet.editor.formatting,
                list: 'no-icons',
                options: [
                    'p',
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'code'
                ]
            },
            {
                label: $q.lang.editor.fontSize,
                icon: $q.iconSet.editor.fontSize,
                fixedLabel: true,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                    'size-1',
                    'size-2',
                    'size-3',
                    'size-4',
                    'size-5',
                    'size-6',
                    'size-7'
                ]
            },
            'removeFormat'
        ],
        ['unordered', 'ordered', 'outdent', 'indent'],
    ]" />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

interface Props {
    editorValue?: string;
}

export default defineComponent({
    name: 'RichTextComponent',
    props: {
        editorValue: { type: String }
    },
    setup(props: Props, { emit }) {
        const showFormModal = computed({
            get() { return props.editorValue ?? '' },
            set(newValue) { emit('update:editorValue', newValue) }
        });
        return {
            showFormModal
        }
    }
})
</script>